// Helper function to extract user ID from "Name (username)" format
export const extractUserId = (userString) => {
  if (!userString) return null;
  const matches = userString.match(/\(([^)]+)\)/);
  if (matches && matches[1]) {
    return matches[1];
  }
  return null;
};

// Helper function to get user first and last name
export const getUserName = (userString) => {
  if (!userString) return "Unknown user";
  const parts = userString.split(" (");
  if (parts.length > 0) {
    return parts[0];
  }
  return userString;
};

// Function to calculate the start date (Monday) of a given week number in a year
export const getWeekStartDate = (year, weekNumber) => {
  // Create a date for January 4th of the given year (guaranteed to be in week 1)
  const jan4 = new Date(year, 0, 4);
  // Get the day of the week for Jan 4 (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
  const jan4Day = jan4.getDay() || 7; // Convert Sunday (0) to 7
  // Calculate the first Monday of the year
  const firstMonday = new Date(year, 0, 4 + (1 - jan4Day));
  // Calculate the start of the desired week (add (weekNumber - 1) weeks)
  const weekStart = new Date(firstMonday);
  weekStart.setDate(firstMonday.getDate() + (weekNumber - 1) * 7);
  return weekStart;
};